import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type SetClinicBrandingMutationVariables = Types.Exact<{
  input: Types.SetBrandingInput;
}>;


export type SetClinicBrandingMutation = { __typename?: 'Mutation', Branding: { __typename?: 'BrandingMutations', setClinicBranding: { __typename?: 'ClinicBranding', clinicId: string, clinicName?: string | null, favicon?: string | null, logo?: string | null, primaryColor?: string | null, tertiaryColor?: string | null, secondaryColor?: string | null, logoFileUuid?: string | null, faviconFileUuid?: string | null } } };

export type GetClinicBrandingQueryVariables = Types.Exact<{
  clinicId: Types.Scalars['String']['input'];
}>;


export type GetClinicBrandingQuery = { __typename?: 'Query', Branding: { __typename?: 'BrandingQueries', getClinicBranding?: { __typename?: 'ClinicBranding', clinicId: string, clinicName?: string | null, favicon?: string | null, logo?: string | null, primaryColor?: string | null, tertiaryColor?: string | null, secondaryColor?: string | null, logoFileUuid?: string | null, faviconFileUuid?: string | null } | null } };


export const SetClinicBrandingDocument = `
    mutation setClinicBranding($input: SetBrandingInput!) {
  Branding {
    setClinicBranding(input: $input) {
      clinicId
      clinicName
      favicon
      logo
      primaryColor
      tertiaryColor
      secondaryColor
      logoFileUuid
      faviconFileUuid
    }
  }
}
    `;
export const GetClinicBrandingDocument = `
    query getClinicBranding($clinicId: String!) {
  Branding {
    getClinicBranding(clinicId: $clinicId) {
      clinicId
      clinicName
      favicon
      logo
      primaryColor
      tertiaryColor
      secondaryColor
      logoFileUuid
      faviconFileUuid
    }
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    setClinicBranding: build.mutation<SetClinicBrandingMutation, SetClinicBrandingMutationVariables>({
      query: (variables) => ({ document: SetClinicBrandingDocument, variables })
    }),
    getClinicBranding: build.query<GetClinicBrandingQuery, GetClinicBrandingQueryVariables>({
      query: (variables) => ({ document: GetClinicBrandingDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useSetClinicBrandingMutation, useGetClinicBrandingQuery, useLazyGetClinicBrandingQuery } = injectedRtkApi;

